<div class="dropdown">
  <div>
    <ion-item lines="none" routerDirection="root" (click)="profile()">
      <ion-icon name="person-outline"></ion-icon>
      <span>Profile</span>
    </ion-item>
    <ion-item
      lines="none"
      routerDirection="root"
      *ngIf="isMultiTenant"
      (click)="switchCompany()"
    >
      <ion-icon name="refresh-outline"></ion-icon>
      <span>Switch Company</span>
    </ion-item>
    <ion-item lines="none" routerDirection="root" (click)="logout()">
      <ion-icon name="log-out-outline"></ion-icon>
      <span>Log Out</span>
    </ion-item>
  </div>
</div>
